<template>
    <b-container fluid class="animated fadeIn">
        <h1>CADASTRO DE EXCEÇÕES</h1>
        <b-card>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Tipo do Evento: *" label-for="tipoEvento" class="text-label">
                        <multiselect
                            name="tipoEvento"
                            v-model="excecao.tipoEvento"
                            :show-labels="false"
                            :options="dados.tiposEvento"
                            :multiple="false"
                            :close-on-select="true"
                            :clear-on-select="true"
                            :preserve-search="false"
                            placeholder="Selecione"
                            track-by="id"
                            label="nome"
                        >
                        </multiselect>
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Número da Dívida:" label-for="numeroDivida" class="text-label">
                        <b-form-input v-model="excecao.numeroDivida" type="text" id="numeroDivida" v-mask="['############']" />
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Número do CNPJ:" label-for="cnpj" class="text-label">
                        <b-form-input v-model="excecao.cnpj" type="text" id="cnpj" v-mask="['##.###.###/####-##']" />
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Número do CNPJ Raiz:" label-for="cnpjRaiz" class="text-label">
                        <b-form-input v-model="excecao.cnpjRaiz" type="text" id="cnpjRaiz" v-mask="['##.###.###']" />
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Número do CPF:" label-for="cpf" class="text-label">
                        <b-form-input v-model="excecao.cpf" type="text" id="cpf" v-mask="['###.###.###-##']" />
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Situação:" label-for="situacao" class="text-label">
                        <b-form-radio-group
                                v-model="excecao.situacao"
                                :options="dados.situacoes"
                                name="situacao"
                        ></b-form-radio-group>
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Motivo:" label-for="motivo" class="text-label">
                        <b-form-input v-model="excecao.motivo" type="text" id="motivo" maxlength="250" />
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4" class="text-center" style="display: flex; flex-direction: column; justify-content: center;">
                    <b-button variant="primary" class="fonte-branca ml-1" @click.prevent="adicionarExcecao" style="width: 100px;">
                        <i class="fa fa-plus"></i> Adicionar
                    </b-button>
                </b-col>
            </b-row>
            <p class="titulo-secao"></p>
            <b-row>
                <b-col md="12">
                    <div class="d-flex justify-content-between" style="display: flex !important; justify-content: center !important; align-items: center;">
                        <div>
                            <b-button variant="primary" class="fonte-branca ml-1" @click="filtrar">
                                <i class="fa fa-search"></i> Pesquisar
                            </b-button>
                            <file-upload
                                    class="btn btn-primary font-branca ml-1"
                                    ref="upload"
                                    :multiple="false"
                                    :maximum="1"
                                    extensions="csv"
                                    v-model="arquivo"
                                    @input-file="anexarCsv"
                                >
                                <i class="fa fa-list" style='padding: 3px;'></i>
                                Incluir Exceções
                            </file-upload>
                            <b-button variant="primary" class="fonte-branca ml-1" @click="abrirExcluir">
                                <i class="fa fa-trash"></i> Excluir
                            </b-button>
                            <b-button class="ml-1" variant="secondary" @click="limparFiltro">
                                <i class="fa fa-eraser"></i> Limpar
                            </b-button>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row class="d-flex justify-content-between">
                <b-col>
                    <label class="mt-3">Exceções - Quantidade: <strong>{{ configTable.rows }}</strong></label>
                </b-col>
                <b-col>
                    <div>
                        <b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage" :total-rows="configTable.rows" size="sm" class="pl-3" style="float:right" v-if="configTable.perPage != 'Todos'">
                        </b-pagination>
                        <b-form-select v-model="configTable.perPage" :options="[100, 500, 1000, 'Todos']" size="sm" class="mb-3 col-2" style="float:right"></b-form-select>
                    </div>
                </b-col>
            </b-row>
            <CompTabelaExcecoes
                :resultado="resultado"
                :fields="fields"
                :configTable="configTable"
                :selecteds="selecteds"
                @sortingChanged="consultar"
                @consultar="consultar" />
            <b-row class="d-flex justify-content-between">
                <b-col></b-col>
                <b-col>
                    <div>
                        <b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage" :total-rows="configTable.rows" size="sm" class="pl-3" style="float:right" v-if="configTable.perPage != 'Todos'">
                        </b-pagination>
                        <b-form-select v-model="configTable.perPage" :options="[100, 500, 1000, 'Todos']" size="sm" class="mb-3 col-2" style="float:right"></b-form-select>
                    </div>
                </b-col>
            </b-row>
            <b-modal ref="modalConfirmar" size="lg" title="Confirmar" cancel-title="Fechar">
                <b-row class="mt-3">
                    <b-col xs="12" md="12" class="mx-auto">
                        <p>Confirmar exclusão de todo o resultado da pesquisa?</p>
                    </b-col>
                </b-row>
                <template v-slot:modal-footer="{  }">
                    <div class="d-flex justify-content-between">
                        <b-button variant="primary" class="fonte-branca ml-1" @click="excluir()">
                            Confirmar
                        </b-button>
                        <b-button variant="secondary" class="fonte-branca ml-1" @click="hideModal('modalConfirmar')">
                            Cancelar
                        </b-button>
                    </div>
                </template>
            </b-modal>
            <b-modal ref="modalUpload" size="lg" title="Confirmar Importação de Exceções em Lote" cancel-title="Fechar">
                <b-row class="mt-3">
                    <b-col xs="12" md="12" class="mx-auto">
                        <p style="font-weight: bold;">Arquivo Selecionado:</p>
                    </b-col>
                    <b-col xs="12" md="12" class="mx-auto">
                        <p>{{ arquivo.length > 0 ? arquivo[0].name : '' }}</p>
                    </b-col>
                </b-row>
                <template v-slot:modal-footer="{  }">
                    <div class="d-flex justify-content-between">
                        <b-button variant="primary" class="fonte-branca ml-1" @click="uploadFile">
                            Confirmar
                        </b-button>
                        <b-button variant="secondary" class="fonte-branca ml-1" @click="hideModal('modalUpload')">
                            Cancelar
                        </b-button>
                    </div>
                </template>
            </b-modal>
            <b-modal ref="modalErrorUpload" size="lg" title="Erro de Importação de Exceções em Lote" cancel-title="Fechar">
                <b-row class="mt-3">
                    <b-col xs="12" md="12" class="mx-auto">
                        <p style="font-weight: bold;">Erro ao importar arquivo:</p>
                    </b-col>
                    <b-col xs="12" md="12" class="mx-auto">
                        <p v-for="erro in errosUpload">{{erro.mensagem}}</p>
                    </b-col>
                </b-row>
                <template v-slot:modal-footer="{  }">
                    <div class="d-flex justify-content-between">
                        <b-button variant="primary" class="fonte-branca ml-1" @click="hideModal('modalErrorUpload')">
                            Fechar
                        </b-button>
                    </div>
                </template>
            </b-modal>
        </b-card>
    </b-container>
</template>

<script>
import axios from 'axios'
import CompTabelaExcecoes from './CompTabelaExcecoes'
import formatarMixins from '../../mixins/formatarMixins'
import VueTagsInput from '@johmun/vue-tags-input';

export default {
    name: 'ManterExcecoes',
    mixins: [ formatarMixins ],
    components: {
        CompTabelaExcecoes,
        VueTagsInput
    },
    data() {
        return {
            excecao: {
                tipoEvento: null,
                numeroDivida: null,
                cnpj: null,
                cnpjRaiz: null,
                cpf: null,
                motivo: null,
                situacao: 0
            },
            listaExcecao: [],
            dados: {
                tiposEvento: [],
                situacoes: [
                    { text: 'Ativo', value: 0 },
                    { text: 'Inativo', value: 1 },
                    { text: 'Ambos', value: 2 }
                ]
            },
            configTableExcecoes: {
                perPage: 10,
                currentPage: 1,
                rows: 0,
                msgEmpty: 'Nenhuma Exceção encontrada.',
                modeSelect: 'single',
                selectable: true,
                limpar: false
            },
            fields: [
                {
                    key: "selecionar",
                },
                {
                    key: '1',
                    label: 'Protesto/Ajuizamento',
                    sortable: true
                },
                {
                    key: '2',
                    label: 'CDA',
                    class: 'text-center',
                    sortable: true
                },
                {
                    key: '3',
                    label: 'CNPJ Raiz',
                    class: 'text-center',
                    sortable: true
                },
                {
                    key: '4',
                    label: 'CNPJ',
                    class: 'text-center',
                    sortable: true
                },
                {
                    key: '5',
                    label: 'CPF',
                    class: 'text-center',
                    sortable: true
                },
                {
                    key: '6',
                    label: 'Usuário',
                    class: 'text-center',
                    sortable: true
                },
                {
                    key: '7',
                    label: 'Data Inclusão',
                    class: 'text-center',
                    sortable: true
                },
                {
                    key: '8',
                    label: 'Data Inativação',
                    class: 'text-center',
                    sortable: true
                },
                {
                    key: '9',
                    label: 'Motivo',
                    class: 'text-center',
                    sortable: true
                },
                {
                    key: '10',
                    label: 'Situação',
                    class: 'text-center',
                    sortable: true
                }
            ],
            configTable: {
                perPage: 100,
                sortField: 'numeroDivida',
                sortOrder: 'asc',
                currentPage: 1,
                rows: 0,
                load: false,
                checkedAll: false
            },
            resultado: [],
            arquivo: [],
            errosUpload: [],
            selecteds: [],
            pesquisar: false
        }
    },
    watch: {
        perPage() {
            this.configTable.checkedAll = false
            this.configTable.currentPage = 1;
            this.consultar();
        }
    },
    computed: {
        perPage() {
            return this.configTable.perPage;
        }
    },
    methods: {
        limparFiltro() {
            this.excecao = {
                tipoEvento: null,
                numeroDivida: null,
                cnpj: null,
                cnpjRaiz: null,
                cpf: null,
                motivo: null,
                situacao: 0
            };
            this.pesquisar = false;
            this.filtrar();
        },
        filtrar() {
            this.configTable.currentPage = 1;
            this.selecteds = [];
            this.consultar();
        },
        async consultar() {
            if((this.excecao.tipoEvento != null && this.excecao.tipoEvento != '')
                    || (this.excecao.numeroDivida != null && this.excecao.numeroDivida != '')
                    || (this.excecao.cnpj != null && this.excecao.cnpj != '')
                    || (this.excecao.cnpjRaiz != null && this.excecao.cnpjRaiz != '')
                    || (this.excecao.cpf != null && this.excecao.cpf != '')
                    || (this.excecao.motivo != null && this.excecao.motivo != '')
                    || (this.excecao.situacao != null && this.excecao.situacao != 0)) {
                this.pesquisar = true;
            }

            const urlApi = process.env.VUE_APP_ROOT_API;

            this.loadingEnter();
            axios.post(`${urlApi}/v1/excecoes/consultar?page=${this.configTable.currentPage}` + this.escapePerPage() + `&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, this.excecao, {
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(response => {
                this.resultado = response.data.resultado;
                this.configTable.rows = response.data.rows;

                this.configTable.checkedAll = true;
                this.resultado.forEach(el => {
                    if (this.selecteds.includes(el.codExcecaoDevedor)) {
                        el.checked = true;
                    } else {
                        this.configTable.checkedAll = false;
                    }
                })
            }).finally(() => {
                this.loadingExit()
            })
        },
        escapePerPage() {
            if (this.configTable.perPage == 'Todos') {
                return '';
            }
            return '&perPage='  + this.configTable.perPage
        },
        validarParametrosExcecao(excecao) {
            let valido = true
            if(excecao) {
                if(!this.excecao.tipoEvento) valido = false
                if(this.excecao.cnpj) {
                    if(this.onlyNumber(this.excecao.cnpj).length != 14 || !this.validarCnpj(this.excecao.cnpj)) {
                        valido = false
                    }
                }
                if(this.excecao.cnpjRaiz) {
                    if(this.onlyNumber(this.excecao.cnpjRaiz).length != 8) {
                        valido = false
                    }
                }
                if(this.excecao.cpf) {
                    if(this.onlyNumber(this.excecao.cpf).length != 11 || !this.validarCpf(this.excecao.cpf)) [
                        valido = false
                    ]
                }
                if(this.excecao.motivo == null || this.excecao.motivo == '') {
                    valido = false;
                }
                var count = 0;
                if(this.excecao.cpf != '' && this.excecao.cpf != null) {
                    count++;
                }
                if(this.excecao.cnpjRaiz != '' && this.excecao.cnpjRaiz != null) {
                    count++;
                }
                if(this.excecao.cnpj != '' && this.excecao.cnpj != null) {
                    count++;
                }
                if(this.excecao.numeroDivida != '' && this.excecao.numeroDivida != null) {
                    count++;
                }

                if(count > 1) {
                    valido = false
                }
            } else {
                valido = false
            }
            return valido
        },

        abrirExcluir() {
            if(this.selecteds.length > 0){
                this.excluir();
            } else if(this.pesquisar){
                this.showModal('modalConfirmar');
            }
        },

        adicionarExcecao() {
            const valido = this.validarParametrosExcecao(this.excecao)
            if(!valido) {
                let msg = []
                if(!this.excecao.tipoEvento) msg.push('O campo Tipo de Evento deve ser informado.')
                if(this.excecao.motivo == null || this.excecao.motivo == '') msg.push('O campo Motivo deve ser informado.')
                if(this.excecao.cnpj) {
                    if(this.onlyNumber(this.excecao.cnpj).length != 14 || !this.validarCnpj(this.excecao.cnpj)) {
                        msg.push('CNPJ inválido.')
                    }
                }
                if(this.excecao.cnpjRaiz) {
                    if(this.onlyNumber(this.excecao.cnpjRaiz).length != 8) {
                        msg.push('CNPJ Raiz inválido.')
                    }
                }
                if(this.excecao.cpf) {
                    if(this.onlyNumber(this.excecao.cpf).length != 11 || !this.validarCpf(this.excecao.cpf)) [
                        msg.push('CPF inválido.')
                    ]
                }

                var count = 0;
                if(this.excecao.cpf != '' && this.excecao.cpf != null) {
                    count++;
                }
                if(this.excecao.cnpjRaiz != '' && this.excecao.cnpjRaiz != null) {
                    count++;
                }
                if(this.excecao.cnpj != '' && this.excecao.cnpj != null) {
                    count++;
                }
                if(this.excecao.numeroDivida != '' && this.excecao.numeroDivida != null) {
                    count++;
                }

                if(count > 1) {
                    msg.push("Apenas um dos campos (CDA, CNPJ Raiz, CNPJ ou CPF) deve ser informado.");
                }

                this.$store.commit("setMessages", { message: 'Atenção', variant: 'danger' , errors: msg });
                window.scrollTo(0,0);
                return
            }

            const urlApi = process.env.VUE_APP_ROOT_API;
            const token = JSON.parse(this.$store.getters.getUser).token.access_token;

            axios.post(`${urlApi}/v1/excecoes/salvar`, this.excecao, {
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json',
                }
            }).then(response => {
                if(response.data) {
                    this.$store.commit("setMessages", { message: 'Atenção', variant: 'danger' , errors: [`${response.data.message}`] });
                    window.scrollTo(0,0);
                    return
                }
                this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: ['Operação realizada com sucesso!!!'] });
                window.scrollTo(0,0)
            }).catch((error) => {
                this.exibirErro(error)
            }).finally(() => {
                this.limparFiltro()
            })
        },

        uploadFile() {
            var arquivosConvertidos = [];
            var file = this.arquivo[0].file;
            var reader = new FileReader();
            reader.onload = function () {
                var arquivoFormatado = {
                    nomeArquivo: file.name,
                    base64: reader.result
                };

                arquivosConvertidos.push(arquivoFormatado);
            };
            reader.readAsDataURL(file);

            reader.onloadend = () => this.executeUpload(arquivosConvertidos);
        },

        executeUpload(arquivosConvertidos){
            const urlApi = process.env.VUE_APP_ROOT_API;
            const token = JSON.parse(this.$store.getters.getUser).token.access_token;

            axios.post(`${urlApi}/v1/excecoes/salvarLote`, arquivosConvertidos[0], {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                }).then(response => {
                    this.errosUpload = response.data;
                if(this.errosUpload != null && this.errosUpload.length > 0) {
                    this.showModal('modalErrorUpload');
                    return
                }
                this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: ['Operação realizada com sucesso!!!'] });
                window.scrollTo(0,0)
            }).catch((error) => {
                    this.exibirErro(error)
            }).finally(() => {
                    this.hideModal('modalUpload');
            });
        },

        async excluir() {
            const urlApi = process.env.VUE_APP_ROOT_API;

            var excecaoExcluidos = {
                tipoEvento: this.excecao.tipoEvento,
                numeroDivida: this.excecao.numeroDivida,
                cnpj: this.excecao.cnpj,
                cnpjRaiz: this.excecao.cnpjRaiz,
                cpf: this.excecao.cpf,
                situacao: this.excecao.situacao,
                listaExcluir: this.selecteds
            };

            this.loadingEnter();
            axios.post(`${urlApi}/v1/excecoes/excluir`, excecaoExcluidos, {
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(response => {
                if(response.data) {
                    this.$store.commit("setMessages", { message: 'Atenção', variant: 'danger' , errors: [`${response.data.message}`] });
                    window.scrollTo(0,0);
                    return
                }
                this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: ['Operação realizada com sucesso!!!'] });
                window.scrollTo(0,0)
            }).catch((error) => {
                this.exibirErro(error)
            }).finally(() => {
                this.hideModal('modalConfirmar');
                this.consultar()
            })
        },

        showModal(id) {
            this.$refs[id].show();
        },

        hideModal(id) {
            this.$refs[id].hide();
        },

        onlyNumber(string) {
            if(string) {
                var numsStr = string.toString().replace(/[^0-9]/g,'');
                return numsStr;
            }
            return null
        },

        voltar() {
            this.$router.push({ path: '/' })
        },

        anexarCsv() {
            this.showModal('modalUpload');
        },

        /**
         * Exibe erros dos catch
         */
        exibirErro(error) {
            this.$store.commit("setMessages", { message: 'Erro!', errors: [error] });
        },

        formatNumeroDivida(e){
            return String(e).substring(0,10);
        },

        /**
         * Listar tipo de evento
         */
        async listarTipoEvento() {
            const urlApi = process.env.VUE_APP_ROOT_API;

            axios.get(`${urlApi}/v1/excecoes/listarTipoEvento`)
            .then(response => {
              this.dados.tiposEvento = response.data
            })
        },
        loadingEnter() {
            this.configTable.load = true
        },
        loadingExit() {
            this.configTable.load = false
        },
    },
    mounted() {
        this.$store.commit("setMessages", {});
        this.listarTipoEvento();
        this.consultar();
        this.selecteds = [];
    }
    
}
</script>

<style scoped>

.titulo-secao {
    border-bottom: 1px solid #CECECE; 
    font-weight: bold; 
    font-style:italic;
    padding-left: 3px;
}

.file-uploads.file-uploads-html5 {
    display: inline-flex;
}

.file-uploads.file-uploads-html4 input, .file-uploads.file-uploads-html5 label {
    cursor: pointer;
}

</style>